/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Display_Save_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to save project: {error}" |
*
* @param {Explorer_Display_Save_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_save_failed_toast = /** @type {((inputs: Explorer_Display_Save_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Save_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'enregistrement du projet : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Projekt konnte nicht gespeichert werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile salvare il progetto: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Проект не удалось сохранить: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo guardar el proyecto: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`项目保存失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プロジェクトの保存に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रोजेक्ट सहेजने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao salvar o projeto: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to save project: ${i?.error}`)
});